import styled from 'styled-components'
import { injectModifiers } from 'ui/themes/utils'
import modifiers from 'ui/themes/modifiers'

const I = styled.i`
  ${({ theme }) => injectModifiers(modifiers(theme))}
`

export default I
